import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to the very top on every route change so pages (blogs, guides, etc.)
// always open from the beginning of their content.
export default function RouteScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
